/**
 * FileUploader (frappe-ui) uses XMLHttpRequest for /api/method/upload_file.
 * Mirror fetch credentials + multitenant site header used by frappeFetchPatch.
 */
import { resolveSiteName } from './config'

const XHR = XMLHttpRequest.prototype
const originalOpen = XHR.open
const originalSend = XHR.send

XHR.open = function patchedOpen(method, url, ...rest) {
  this.__frappeUrl = typeof url === 'string' ? url : String(url || '')
  return originalOpen.call(this, method, url, ...rest)
}

XHR.send = function patchedSend(body) {
  const url = this.__frappeUrl || ''
  if (url.includes('/api/')) {
    try {
      this.withCredentials = true
    } catch {
      /* ignore */
    }
    try {
      const site = resolveSiteName(window.site_name)
      if (site) {
        this.setRequestHeader('X-Frappe-Site-Name', site)
      }
    } catch {
      /* setRequestHeader may throw if already sent */
    }
  }
  return originalSend.call(this, body)
}
